import { useEffect, useCallback } from 'react';

interface Props {
  onCompose: () => void;
  onReply: () => void;
  onReplyAll: () => void;
  onForward: () => void;
  onArchive: () => void;
  onNext: () => void;
  onPrev: () => void;
  onBackToList: () => void;
  onSearch: () => void;
  onToggleFocus: () => void;
  onEscape: () => void;
  enabled?: boolean;
}

export function InboxKeyboardHandler({
  onCompose, onReply, onReplyAll, onForward, onArchive,
  onNext, onPrev, onBackToList, onSearch, onToggleFocus, onEscape,
  enabled = true,
}: Props) {
  const handleKey = useCallback((e: KeyboardEvent) => {
    if (!enabled) return;
    const target = e.target as HTMLElement;
    const inInput = target.tagName === 'INPUT'
      || target.tagName === 'TEXTAREA'
      || target.isContentEditable
      || target.closest('[role="textbox"]') !== null;
    if (inInput) return;
    if (e.metaKey || e.ctrlKey || e.altKey) return;

    switch (e.key) {
      case 'c': e.preventDefault(); onCompose(); break;
      case 'r': e.preventDefault(); onReply(); break;
      case 'a': e.preventDefault(); onReplyAll(); break;
      case 'f': e.preventDefault(); onForward(); break;
      case 'e': e.preventDefault(); onArchive(); break;
      case 'j': e.preventDefault(); onNext(); break;
      case 'k': e.preventDefault(); onPrev(); break;
      case 'u': e.preventDefault(); onBackToList(); break;
      case '/': e.preventDefault(); onSearch(); break;
      case 'F': e.preventDefault(); onToggleFocus(); break;
      case 'Escape': onEscape(); break;
    }
  }, [
    enabled, onCompose, onReply, onReplyAll, onForward, onArchive,
    onNext, onPrev, onBackToList, onSearch, onToggleFocus, onEscape,
  ]);

  useEffect(() => {
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [handleKey]);

  return null;
}
